module.exports = __webpack_public_path__ + "static/kelsie-4-de02b1c12064378db5edeec4479be2ce.jpg";